import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconPaintPalette({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.375} d="M16 15.62c.3 3.86 6 1.21 5.56 2.54-2.52 7.48-12.64 5.69-17 1.17A10.9 10.9 0 0 1 4.64 4C8.87-.19 16-.5 19.93 4c7.63 8.86-4.17 8.18-3.93 11.62" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.375} d="M7.19 14.83a1.52 1.52 0 1 0 0-3.04 1.52 1.52 0 0 0 0 3.04M10.95 19.66a1.52 1.52 0 1 0 0-3.04 1.52 1.52 0 0 0 0 3.04M14.59 7.43a1.52 1.52 0 1 0 0-3.04 1.52 1.52 0 0 0 0 3.04M8.14 9.04a1.52 1.52 0 1 0 0-3.04 1.52 1.52 0 0 0 0 3.04" /></svg></>;
}
export default IconPaintPalette;